import { render } from "./SimpleAlert.vue?vue&type=template&id=557ad4e7"
import script from "./SimpleAlert.vue?vue&type=script&lang=js"
export * from "./SimpleAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__